import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { XIcon } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = [{
    title: 'Ignorar el sentimiento',
    desc: 'Pensar que "todas las parejas pasan por esto" solo hace que el resentimiento se pudra por dentro.'
  }, {
    title: 'Esperar a que él cambie primero',
    desc: 'Cederle el control de tu felicidad a alguien que quizás ni siquiera entiende qué está pasando.'
  }, {
    title: 'Fingir cansancio',
    desc: 'Usar el sueño como escudo para evitar la intimidad solo levanta muros de rechazo que luego son imposibles de derribar.'
  }];
  return <section id="problem" className="py-24 px-4 md:px-8 bg-cream relative" data-id="element-221">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-222">
        <FadeIn data-id="element-223">
          <div className="space-y-8 text-lg md:text-xl text-charcoal leading-[1.8]" data-id="element-224">
            <p data-id="element-225">
              La mayoría de las mujeres intentan arreglar esto con soluciones
              superficiales: lencería nueva, viajes de fin de semana o forzando
              conversaciones que terminan en reproches.
            </p>
            <p className="relative inline-block" data-id="element-226">
              Pero nada funciona porque no estás atacando la raíz. Tu falta de
              deseo y esa sensación de soledad no son el problema; son los
              síntomas de un{' '}
              <span className="relative inline-block" data-id="element-227">
                <strong className="text-burgundy font-serif text-2xl font-semibold relative z-10" data-id="element-228">
                  Vacío Emocional Femenino
                </strong>
                <motion.span initial={{
                width: 0
              }} whileInView={{
                width: '100%'
              }} transition={{
                duration: 1,
                delay: 0.5,
                ease: 'easeOut'
              }} viewport={{
                once: true
              }} className="absolute bottom-0 left-0 h-2 bg-gold/30 -z-0 rounded-full" data-id="element-229" />
              </span>{' '}
              que ha crecido en el silencio.
            </p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.3
          }} className="relative p-8 md:p-10 bg-gradient-to-br from-rose-light/80 to-cream-light rounded-3xl border border-rose/20 mt-12 shadow-sm" data-id="element-230">
              <div className="absolute -top-6 -left-4 text-8xl font-serif text-burgundy opacity-10 leading-none select-none" data-id="element-231">
                "
              </div>
              <div className="absolute left-0 top-8 bottom-8 w-1 bg-gold rounded-r-full" data-id="element-232"></div>
              <p className="italic text-xl md:text-2xl font-serif text-burgundy-dark relative z-10 pl-4" data-id="element-233">
                Tu "yo" operativa (la madre y la administradora) ha aplastado a
                tu "yo" mujer, y tu esposo ha dejado de verte porque tú misma
                has dejado de verte.
              </p>
            </motion.div>
          </div>
        </FadeIn>

        <FadeIn className="my-16 flex justify-center" data-id="element-234">
          <div className="relative" data-id="element-235">
            <div className="absolute -inset-3 bg-gradient-to-br from-rose/20 to-gold/20 rounded-full blur-xl" data-id="element-236"></div>
            <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&q=80" alt="Mujer pensativa en un momento de reflexión profunda" className="relative w-56 h-56 md:w-72 md:h-72 rounded-full object-cover object-top border-4 border-white shadow-2xl" data-id="element-237" />
          </div>
        </FadeIn>

        <div className="mt-12" data-id="element-238">
          <FadeIn data-id="element-239">
            <h3 className="text-2xl md:text-3xl font-serif text-burgundy-dark mb-12 text-center" data-id="element-240">
              Por qué lo que has intentado no funciona
            </h3>
          </FadeIn>

          <div className="space-y-6" data-id="element-241">
            {failedAttempts.map((attempt, idx) => <FadeIn key={idx} delay={0.2 + idx * 0.15} direction="up" data-id="element-242">
                <div className="group relative flex items-start gap-5 p-6 md:p-8 bg-white rounded-2xl shadow-sm border border-cream-dark hover:shadow-lg transition-all duration-500 overflow-hidden" data-id="element-243">
                  <motion.div initial={{
                height: 0
              }} whileInView={{
                height: '100%'
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.8,
                delay: 0.4 + idx * 0.15
              }} className="absolute left-0 top-0 w-1 bg-burgundy/60" data-id="element-244" />
                  <div className="mt-1 bg-rose-light p-3 rounded-full text-burgundy shrink-0 group-hover:scale-110 group-hover:bg-rose transition-all duration-300" data-id="element-245">
                    <XIcon className="w-5 h-5" data-id="element-246" />
                  </div>
                  <div data-id="element-247">
                    <h4 className="font-bold text-charcoal text-lg mb-2 font-serif text-xl" data-id="element-248">
                      {attempt.title}
                    </h4>
                    <p className="text-charcoal-light leading-relaxed" data-id="element-249">
                      {attempt.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}